import React from 'react';
import { Container, Paper, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const Booking = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Paper elevation={3} sx={{ p: 4 }}>
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '20px' }}>
            <iframe 
              src="https://forms.gle/gRVEh2osryWg5h839" 
              width="100%" 
              height="1600px" 
              frameBorder="0" 
              marginHeight="0" 
              marginWidth="0"
              title="Booking Form"
            >
              Loading form...
            </iframe>
          </div>
        </Paper>
      </motion.div>
    </Container>
  );
};

export default Booking;